import { useState, useEffect } from 'react';

const Loading = () => {
    const [loadingQuote, setLoadingQuote] = useState('');


    const gtmQuotes = [
        "Spotting who's silent, not just who's loud",
        'Great GTM is about relevance, not reach.',
        'In B2B SaaS, timing is as important as targeting.',
        'Winning teams listen to signals, not just noise.',
        'Every deal is a story—find the pattern.',
        'GTM is a team sport: align, act, adapt.',
        'The best SaaS sellers are pattern matchers.',
        'Progress is measured in signals, not just stages.',
        'The right message, to the right persona, at the right time.',
        'GTM is about orchestrating momentum.'
      ];
    


    useEffect(() => {
        let intervalId; // eslint-disable-line
        if (true) {
          setLoadingQuote(gtmQuotes[Math.floor(Math.random() * gtmQuotes.length)]);
          intervalId = setInterval(() => {
            setLoadingQuote(gtmQuotes[Math.floor(Math.random() * gtmQuotes.length)]);
          }, 3000);
        }
        return () => {
          if (intervalId) clearInterval(intervalId);
        };
      }, [true]);

    return (
       
         
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 320,
          background: '#fff',
          borderRadius: 16,
          boxShadow: '0 4px 32px rgba(0,0,0,0.08)',
          color: '#1f2937',
          padding: '48px 24px',
          margin: '32px auto',
          maxWidth: 520,
          animation: 'fadeIn 0.5s',
          border: '1px solid #e5e7eb'
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginBottom: 32
          }}>
            <div style={{
              width: 64,
              height: 64,
              borderRadius: '50%',
              background: 'rgba(59, 130, 246, 0.10)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 18
            }}>
              <span style={{ fontSize: 36, color: '#3b82f6' }}>🧠</span>
            </div>
            <div style={{
              fontWeight: 700,
              fontSize: 22,
              textAlign: 'center',
              marginBottom: 8,
              color: '#1f2937',
              letterSpacing: 0.2
            }}>
              {loadingQuote}
            </div>
            <div style={{
              fontSize: 15,
              color: '#3b82f6',
              textAlign: 'center',
              marginBottom: 8
            }}>
              Hold on — pulling patterns from signals
            </div>
          </div>
          {/* Progress bar */}
          
          {/* Steps */}
          <div style={{
            marginTop: 2,
            width: '100%',
            maxWidth: 340,
            display: 'flex',
            flexDirection: 'column',
            gap: 10
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              color: '#10b981',
              fontWeight: 500,
              fontSize: 15
            }}>
              <span style={{ fontSize: 18 }}>●</span> CRM data parsed
            </div>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              color: '#3b82f6',
              fontWeight: 500,
              fontSize: 15
            }}>
              <span style={{ fontSize: 18 }}>●</span> Signal patterns identified
            </div>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              color: '#a21caf',
              fontWeight: 500,
              fontSize: 15
            }}>
              <span style={{ fontSize: 18 }}>●</span> Generating insights
            </div>
          </div>
        </div>
      )}
        
    


export default Loading;